import { Button } from '../primitives/button';
import { useConsent } from './consent-context';

interface ConsentBannerProps {
  privacyHref?: string;
  cookiesHref?: string;
}

export function ConsentBanner({ privacyHref = '/legal/privacy', cookiesHref = '/legal/cookies' }: ConsentBannerProps) {
  const { hasDecided, acceptAll, rejectAll, open } = useConsent();

  if (hasDecided) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-labelledby="consent-banner-title"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/85 shadow-lg"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="text-sm text-foreground/90 sm:max-w-2xl">
          <p id="consent-banner-title" className="font-medium">
            Cookies and analytics
          </p>
          <p className="mt-1 text-muted-foreground">
            We use strictly necessary cookies to run Inferrex. With your consent, we also use analytics
            cookies (Google Analytics) to understand how the site is used so we can improve it. You
            can change your mind any time from the footer. Read the{' '}
            <a href={privacyHref} className="underline underline-offset-2 hover:text-foreground">
              privacy policy
            </a>{' '}
            and{' '}
            <a href={cookiesHref} className="underline underline-offset-2 hover:text-foreground">
              cookie notice
            </a>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <Button variant="ghost" size="sm" onClick={open}>
            Manage preferences
          </Button>
          <Button variant="outline" size="sm" onClick={rejectAll}>
            Reject non-essential
          </Button>
          <Button variant="default" size="sm" onClick={acceptAll}>
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
}
